import { stock } from '@/data/stockImages';

// Doğrudan cevap (A). Hedef: kafe sipariş sistemi, restoran sipariş sistemi, garson sipariş programı.
export default [
  {
    t: 'p',
    text: 'Kafe sipariş sistemi, siparişin alındığı andan hesabın kapatıldığı ana kadar geçen süreci kaydeden yazılımdır. Garson siparişi telefondan ya da tabletten girer, sipariş ilgili masaya işlenir, hazırlayacak kişiye (barista, aşçı) bildirim gider ve masanın hesabı kendiliğinden oluşur. Kâğıt adisyonun yaptığı işi yapar, ama kaydı herkesle aynı anda paylaşır.',
  },
  {
    t: 'p',
    text: 'Aşağıda sipariş sisteminin parçalarını, siparişin hangi kanallardan gelebileceğini ve bir sistemi değerlendirirken nelere bakmak gerektiğini anlatıyoruz.',
  },
  { t: 'h2', text: 'Bir sipariş sisteminin parçaları' },
  { t: 'h3', text: 'Sipariş girişi' },
  {
    t: 'p',
    text: 'Garson masayı seçer, ürünleri kategorilerden bulur, adetleri girer ve kaydeder. “Az şekerli”, “soğansız” gibi istekler ürüne not olarak eklenir. Girişin hızlı olması önemlidir: yoğun saatte ürün aramak için harcanan her saniye masada bekleyen müşteriye yansır.',
  },
  {
    t: 'guide',
    image: '12-siparis-ekle',
    alt: 'Garsonun kategori filtreleriyle ürün seçip masaya sipariş eklediği ekran',
    caption: 'Sipariş girişi: kategoriye göre ürün seçimi, adet ve sipariş notu.',
  },
  { t: 'h3', text: 'Siparişin hazırlayana ulaşması' },
  {
    t: 'p',
    text: 'Kâğıt adisyonda sipariş, garson mutfağa ya da bara yürüdüğünde iletilir. Sipariş sisteminde ise kaydedildiği anda hazırlayacak kişinin ekranına ve telefonuna düşer. Kahve siparişinin baristaya, yemek siparişinin aşçıya gitmesi gibi ürün bazında yönlendirme, özellikle hem mutfağı hem barı olan işletmelerde karışıklığı azaltır.',
  },
  { t: 'h3', text: 'Durum takibi' },
  {
    t: 'p',
    text: 'Sipariş “hazırlanıyor”, “hazır” ve “teslim edildi” gibi aşamalardan geçer. Bu aşamaların görünmesi, garsonun mutfağa gidip sormasını gereksiz kılar ve bekleyen siparişlerin gözden kaçmasını önler.',
  },
  { t: 'h3', text: 'Masa ve hesap' },
  {
    t: 'p',
    text: 'Her sipariş masanın açık hesabına eklenir. Masalar ekranında hangi masanın dolu olduğu ve ne kadar hesabı olduğu görünür; bazı sistemler bunu bir [restoran krokisi](/blog/restoran-kroki-sistemi) üzerinde gösterir. Hesap kapatılırken ödeme yöntemi seçilir; kalabalık masalarda hesap bölünebilir, yer değiştiren müşterinin siparişi başka masaya aktarılabilir.',
  },
  {
    t: 'guide',
    image: '14-hesap-ozeti',
    alt: 'Hesap özeti ekranında ödeme yöntemi seçimi, parçalı ödeme ve masa aktarma',
    caption: 'Hesap özeti: ödeme yöntemi, parçalı ödeme ve masa aktarma.',
  },
  { t: 'h2', text: 'Sipariş hangi kanallardan gelir?' },
  {
    t: 'table',
    head: ['Kanal', 'Nasıl işler?', 'Nerede uygun?'],
    rows: [
      ['Garson (masa)', 'Garson siparişi telefon ya da tabletten masaya girer', 'Masa servisi yapan her işletme'],
      ['QR menü', 'Müşteri menüden sipariş verir, personel onaylar', 'Yoğun saatleri olan kafe ve restoranlar'],
      ['Kasa', 'Sipariş tezgâhta alınır, ödeme orada yapılır', 'Self servis ve paket satış yapan kafeler'],
    ],
  },
  {
    t: 'p',
    text: 'Çoğu kafe birden fazla kanalı birlikte kullanır: salonda garson, yoğun saatlerde QR menü, tezgâhta paket satış. Önemli olan hepsinin aynı sisteme düşmesi; aksi hâlde gün sonunda üç ayrı kaydı birleştirmek gerekir. QR menüden sipariş akışının ayrıntısını [QR kod ile masadan sipariş](/blog/qr-kod-ile-masadan-siparis) yazısında anlattık.',
  },
  { t: 'h2', text: 'Kâğıt adisyondan geçince ne değişir?' },
  {
    t: 'img',
    img: stock('garson-tablet', 'Elinde tabletle sipariş alan garson'),
  },
  {
    t: 'list',
    items: [
      '**Okunmayan el yazısı ve kayıp adisyon** sorunu ortadan kalkar; sipariş yazıldığı gibi görünür.',
      '**Açık hesaplar** tek ekranda toplanır. Gün sonunda kapatılmamış bir masa gözden kaçmaz.',
      '**Satış kaydı kendiliğinden oluşur.** Hangi ürünün ne kadar sattığı, günün cirosu ayrıca hesaplanmadan raporlarda görünür.',
      '**Stok bağlantısı kurulabilir.** Ürünlere reçete tanımlanırsa her satış stoktan düşer; ayrıntısı [stok takibi](/blog/stok-takibi-nasil-yapilir) yazısında.',
    ],
  },
  {
    t: 'p',
    text: 'Geçişin zor kısmı genellikle ilk haftadır: ürünlerin sisteme girilmesi ve personelin yeni ekrana alışması. Ürün adlarının ve kategorilerin kasadakiyle aynı tutulması, bu süreyi kısaltır.',
  },
  { t: 'h2', text: 'Sipariş sistemi seçerken bakılacaklar' },
  {
    t: 'list',
    items: [
      'Garsonlar kendi telefonlarından kullanabiliyor mu, yoksa her biri için cihaz almak mı gerekiyor?',
      'Sipariş, ürün türüne göre farklı kişilere (barista, aşçı) yönlendirilebiliyor mu?',
      'QR menü ve kasa siparişleri aynı sisteme mi düşüyor?',
      'Hesap bölme, masa aktarma ve farklı ödeme yöntemleri destekleniyor mu?',
      'Personel yetkileri ayrılabiliyor mu? Garsonun iptal ya da indirim yetkisinin sınırlı olması gerekebilir.',
    ],
  },
  {
    t: 'p',
    text: 'Daha kapsamlı bir kontrol listesi için [kafe ve restoran yönetim programı seçimi](/blog/kafe-restoran-yonetim-programi-secimi) yazısına bakabilirsiniz.',
  },
  { t: 'h2', text: 'Tilki Otomasyon’da sipariş' },
  {
    t: 'p',
    text: 'Tilki’de garson siparişi web panelinden ya da iOS/Android uygulamasından girer; sipariş, ürün ayarlarında seçtiğiniz çalışan tiplerine (örneğin barista ya da aşçı) bildirim olarak gider. Menüden ve kasadan gelen siparişler de aynı “Siparişler” ekranında toplanır. Adım adım anlatım [rehberin sipariş bölümünde](/nasil-kullanilir#siparis).',
  },
  {
    t: 'cta',
    title: 'Sipariş akışınızı birlikte kuralım',
    text: 'Ücretsiz demo talep edin; masalarınızı ve menünüzü girip sipariş akışını kendi işletmeniz üzerinde gösterelim.',
    to: '/demo',
    label: 'Ücretsiz demo alın',
  },
];

export const faq = [
  {
    q: 'Sipariş sistemi için garsonlara tablet almak gerekir mi?',
    a: 'Gerekmeyebilir. Bulut tabanlı sistemlerin çoğu telefonda da çalışır. Tilki’nin iOS ve Android uygulaması olduğu için garsonlar kendi telefonlarını kullanabilir; tablet, ekranı büyük olduğu için kasa ya da mutfak için tercih edilebilir.',
  },
  {
    q: 'Mutfak siparişi nasıl görür?',
    a: 'Sipariş kaydedildiğinde, o ürünü hazırlayacak çalışan tipine bildirim gider ve sipariş “Siparişler” ekranında görünür. Aşçı ya da barista siparişi ekrandan takip edip hazır olduğunda işaretler.',
  },
  {
    q: 'Sipariş sistemi ile adisyon programı aynı şey mi?',
    a: 'Büyük ölçüde evet. “Adisyon programı” genellikle masaya sipariş yazıp hesap kapatan yazılım için kullanılır. Sipariş sistemi ise buna QR menü, kasa siparişi ve bildirim gibi kanalları da ekleyen daha geniş bir kavramdır.',
  },
];
